var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatExpandBtnHoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 1,
    stroke: "#24B8E1",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 1,
    width: 5,
    height: 22,
    fill: "#24B8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13C19.0523 13 19.5 12.5523 19.5 12C19.5 11.4477 19.0523 11 18.5 11V13ZM18.5 11H7.5V13H18.5V11Z",
    fill: "#24B8E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12L11 8.5359L11 15.4641L5 12Z",
    fill: "#24B8E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatExpandBtnHoverIcon);
export default __webpack_public_path__ + "static/media/chatExpandBtnHoverIcon.3b83a59a87d97db86db755126d3e6c9f.svg";
export { ForwardRef as ReactComponent };